module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<label class=\"text-muted small\">Balance</label> <div id=\"balance_loader\" class=\"loader\"></div> ")
    ;  if (locals.firstFetchSuccess) { 
    ; __append(" <div class=\"d-flex align-items-center justify-content-center\"> <h1 class=\"display-4 balance\">")
    ; __append(escapeFn( locals.balance ))
    ; __append("</h1> <div id=\"one_time_charge\"></div> </div> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/billing/account_balance/template.ejs
// module id = 1258
// module chunks = 1